import type { JSX } from 'react';
import { Link, useParams } from 'react-router-dom';

import Debug from '@/components/Debug';
import PageHeader from '@/components/PageHeader';
import RemitForm from '@/forms/RemitForm/RemitForm';
import useAPI from '@/hooks/useAPI';
import RemitRepository from '@/repositories/RemitRepository';
import Card from '@/ui/components/Card';
import Container from '@/ui/components/Container';
import Spinner from '@/ui/components/Spinner';

const EditRemit = (): JSX.Element | null => {
  const remitRepo = RemitRepository();
  const { id } = useParams<{ id: string }>();
  const getRemitQuery = useAPI({
    queryKey: ['getRemit', id],
    queryFn: async () => {
      return await remitRepo.getRemit({
        remitID: id || ''
      });
    }
  });

  const { data, isPending } = getRemitQuery;
  const remit = data?.data;

  return (
    <Container type="page">
      <PageHeader headingText="Edit Remit"></PageHeader>
      {isPending && <Spinner></Spinner>}

      {!remit && !isPending && <div>Remit not found</div>}

      <Card className="relative">
        {remit && !isPending && <RemitForm remit={remit}></RemitForm>}
        <Debug object={remit as object} />
      </Card>

      <Link to="/billing" className="btn btn-secondary">
        Back
      </Link>
    </Container>
  );
};

export default EditRemit;
